/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import {
  Box,
  Button,
  Link,
  OutlinedInput,
  styled,
  TextField,
  Typography,
} from "@mui/material";

export const IntegrationContainer = styled(Box)(
  ({ drawerOpen, drawerWidth }) => ({
    height: "100%",
    width: drawerOpen ? `calc(100% - ${drawerWidth}px)` : "100%",
    overflowY: "scroll",
    overflowX: "hidden",
  })
);

export const StyledAddButton = styled(Button)({
  "&.Mui-disabled": {
    backgroundColor: "#001b59",
  },
  "&:hover": {
    textTransform: "none",
    fontWeight: "600",
    boxShadow: "none",
    backgroundColor: "#001b59",
    borderRadius: "8px",
    padding: "0px 30px",
  },
  textTransform: "none",
  fontWeight: "600",
  boxShadow: "none",
  backgroundColor: "#395bbd",
  borderRadius: "8px",
  padding: "0px 30px",
  width: "20%",
});

export const StyledBreadCrumbContainer = styled("div")({
  height: "20px",
  width: "100%",
  backgroundColor: "#f5f5f8",
  padding: "10px 0px 10px 20px",
  borderColor: "#e0e0e0",
  borderWidth: "0px 0px 1px 0px",
  borderStyle: "solid",
});

export const StyledButtonContainer = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  padding: "15px 20px 5px 20px",
});

export const StyledCancelButton = styled(Button)({
  "&:hover": {
    textTransform: "none",
    fontWeight: "600",
    boxShadow: "none",
    border: "2px solid #001b59",
    borderRadius: "8px",
    color: "#001b59",
  },
  textTransform: "none",
  fontWeight: "600",
  boxShadow: "none",
  border: "2px solid #395bbd",
  borderRadius: "8px",
  color: "#395bbd",
  width: "20%",
});

export const StyledCreateButton = styled(Button)({
  textTransform: "none",
  fontWeight: "600",
  boxShadow: "none",
});

export const StyledCreateTitle = styled(Typography)({
  fontSize: "34px",
  fontWeight: "700",
  marginTop: "10px",
  textAlign: "center",
  wordWrap: "break-word",
});

export const StyledFormContainer = styled("div")({
  marginTop: "10%",
});

export const StyledFormFieldText = styled(Typography)({
  fontWeight: "600 !important",
  fontSize: "15px !important",
  marginBottom: "5px",
});

export const StyledLink = styled(Link)(({ color }) => ({
  textDecoration: "none",
  color: color,
  fontSize: "13px",
  fontWeight: "400",
}));

export const StyledTextField = styled(TextField)({
  "&:hover": {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "2px solid #395bbd !important",
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px",
    borderRadius: "8px",
  },
});

export const StyledTitle = styled(Typography)({
  fontSize: "24px",
  fontWeight: "700",
  lineHeight: "40px",
});

export const StyledTitleContainer = styled("div")({
  padding: "20px 0px 10px 0px",
});

export const StyledPasswordField = styled(OutlinedInput)({
  "&:hover": {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "2px solid #395bbd !important",
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px",
    borderRadius: "8px",
  },
});

export const StyledHelperText = styled("div")({
  color: "#d32f2f",
  fontSize: "0.75rem",
  paddingTop: "5px",
  letterSpacing: "0.3px",
  marginLeft: "12px",
});
